module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM20 17a1 1 0 0 1-1 1h-1v7a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-7h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slider-3.js
// module id = 1422
// module chunks = 14